import { useMemo } from 'react'

import { clsx } from 'clsx'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useBrowserTimeZone } from '../../../../common/index.js'
import { getEventFormattedDate } from '../../../utils.js'

interface Props {
  type?: 'inline' | 'multi-line'
  startTime: string
  endTime: string
  highlighted?: boolean
  hideDay?: boolean
  className?: string
  timeZone?: string
  hideTime?: boolean
}

export const EventDate = ({
  type = 'inline',
  startTime,
  endTime,
  highlighted,
  hideDay,
  className,
  timeZone,
  hideTime,
}: Props) => {
  const browserTimeZone = useBrowserTimeZone()

  const { date, time } = useMemo(() => {
    return getEventFormattedDate({
      startTime,
      endTime,
    })
  }, [startTime, endTime])

  if (type === 'multi-line') {
    return (
      <div
        className={clsx(
          className,
          'text-sm space-y-1',
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        )}
      >
        {!hideDay && (
          <div className="flex items-center">
            <SvgIcon name="calendar" />
            <span className="ml-1 min-w-0 truncate">{date}</span>
          </div>
        )}
        {!hideTime && (
          <div className="flex items-center">
            <SvgIcon name="clock" />
            <span className="ml-1 min-w-0 truncate">
              {timeZone ? `${time} (${browserTimeZone})` : time}
            </span>
          </div>
        )}
      </div>
    )
  }

  return (
    <div
      className={clsx(
        className,
        'flex items-center min-w-0 text-sm gap-1',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
      )}
    >
      {!hideDay && (
        <div className="flex items-center min-w-0">
          <div className="pr-1">
            <SvgIcon name="calendar" />
          </div>
          <span className="mr-1 min-w-0 truncate">{date}</span>
        </div>
      )}
      {!hideTime && (
        <div className="flex items-center min-w-0">
          <div className="pr-1">
            <SvgIcon name="clock" />
          </div>
          <span className="min-w-0 truncate">
            {timeZone ? `${time} (${browserTimeZone})` : time}
          </span>
        </div>
      )}
    </div>
  )
}
